module.exports = __webpack_public_path__ + "img/footer_calling.ca86f851.png";